import { useEffect, useState } from "react";
import { MdArrowBack } from "react-icons/md";
import { toast } from "react-toastify";
import { getDeletedArticles, recoverArticle } from "../../api/helpCenterApi";
import LoadingSpinner from "../LoadingSpinner";
import CategoryCard from "./CategoryCard";
import logo_icon from "../../assets/cargotool-icon.png";
import { FiHelpCircle } from "react-icons/fi";

const HelpCenterDeletedArticles = ({
  deletedHelpTopics,
  setDeletedHelpTopics,
  setSelectedKey,
  selectedKey,
  setUpdateNeeded,
}) => {
  const [isRecovering, setIsRecovering] = useState(false);
  const [isArticleLoading, setIsArticleLoading] = useState(false);
  const handleBack = () => {
    setSelectedKey(null);
  };

  const handleRecover = async (articleId) => {
    setIsRecovering(true);
    try {
      await recoverArticle(articleId);
      setDeletedHelpTopics(
        deletedHelpTopics?.filter((article) => article.articleId !== articleId)
      );
      setUpdateNeeded(true);
      toast.success("Article Recovered successfully", {
        autoClose: 5000,
        containerId: "Modal",
      });
    } catch (error) {
      console.error("Failed to recover article:", error);
      toast.error("Failed to recover article.", {
        autoClose: 5000,
        containerId: "Modal",
      });
    }
    setIsRecovering(false);
  };

  const fetchArticles = async () => {
    setIsArticleLoading(true);

    const deletedArticles = await getDeletedArticles();
    if (deletedArticles && deletedArticles.length > 0) {
      const articlesWithIcons = deletedArticles?.map((article) => ({
        ...article,
        key: 1, // or article.articleId,
        icon: <FiHelpCircle size={45} />,
        docCount: article.documents?.length,
        isVideo: article.videoEmbedHtml !== "" ? true : false,
      }));
      setDeletedHelpTopics(articlesWithIcons);
    } else {
      setDeletedHelpTopics([]);
    }

    setIsArticleLoading(false);
  };

  useEffect(() => {
    fetchArticles();
  }, []);

  return (
    <>
      {isArticleLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <div className="help-center-search-res-sub-container">
            <div className="help-center-sub-header">
              <div
                className="help-center-sub-logo-header"
                style={{
                  position: "absolute",
                  left: 20,
                  top: 20,
                  cursor: "pointer",
                  zIndex: "1000",
                }}
              >
                <img
                  src={logo_icon}
                  alt="logo-icon"
                  className="help-center-logo-icon"
                />
                <div className="help-center-logo">HELP CENTER</div>
              </div>
              <MdArrowBack
                color="black"
                size={30}
                className="help-back-icon"
                onClick={handleBack}
                style={{
                  position: "absolute",
                  right: 60,
                  top: 20,
                  cursor: "pointer",
                  zIndex: "1000",
                }}
              />
            </div>

            <div className="help-center-sub-deleted-title">
              <h3 className="sub-text-title">Deleted Help Articles</h3>
              <div>
                {deletedHelpTopics.length ? (
                  <h4 className="sub-text-deleted-des">
                    Found {deletedHelpTopics.length} topic
                    {deletedHelpTopics.length > 1 ? "s deleted" : " deleted"}
                  </h4>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      marginTop: "10px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "10px",
                      }}
                    >
                      <h2 style={{ color: "black" }}>
                        No help Center articles deleted.
                      </h2>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div
            style={{
              padding: "0 20px 40px 20px",
              cursor: "pointer",
              height: "70vh",
              overflowY: "auto",
            }}
          >
            {deletedHelpTopics?.map((topic) => (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <CategoryCard
                  icon={topic.icon}
                  title={topic.title}
                  description={topic.slug}
                  views={topic.viewCount}
                  recover={true}
                  isVideo={topic.isVideo}
                  docCount={topic.docCount}
                  //    onClick={() => handleArticleClick(topic)}
                  onRecoverClick={() => {
                    handleRecover(topic.articleId);
                  }}
                />
              </div>
            ))}
          </div>
          {isRecovering && (
            <div className="blur-overlay">
              <LoadingSpinner message={`Recovering ...`} />
            </div>
          )}
        </>
      )}
    </>
  );
};

export default HelpCenterDeletedArticles;

const styles = `
  .blur-overlay {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
    z-index: 9999; /* Ensure it's on top of everything */
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .blurred {
    filter: blur(5px); /* Blur effect on content */
    pointer-events: none; /* Prevent interaction with blurred content */
  }
`;

document.head.insertAdjacentHTML("beforeend", `<style>${styles}</style>`);
